import { Fragment, FunctionalComponent } from 'preact';
import styles from './styles.module.scss';

const textStyles =
  typeof window === 'undefined' ? { color: 'transparent' } : {};

const formatNumber = (number: number) => {
  // If the number is more than 10000, then we want to abbreviate it
  if (number > 10000) {
    // If the number is more than 1000000, then we want to abbreviate it
    if (number > 1000000) {
      return `${(number / 1000000).toFixed(1)}M`;
    }

    return `${(number / 1000).toFixed(1)}K`;
  }

  return number;
};

const Counter: FunctionalComponent = () => {
  const state = localStorage.getItem('state');

  const parsedState = JSON.parse(state || '{}');

  const totalShells = parsedState?.user?.shells?.shellsCounter || 0;

  const bottles = Math.floor(totalShells / 100);
  const shells = totalShells % 100;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '2rem',
      }}
    >
      <div
        className={`${styles.counterOuter} ${styles.shellsCounter} shellsCounterTC`}
      >
        <div>
          <div className={styles.counter}>
            <div className={`${styles.counterIcon} ${styles.shell}`} />
            <span style={textStyles}>{shells}</span>
          </div>

          {/* <div className={styles.popover}>
            <div className={styles.outerPopover}>
              <div className={styles.innerPopover}>
                <p className={styles.description}>
                  {getTranslation('new_tab_shell_counter_description')}
                </p>

                <footer className={styles.footer}>
                  <div>
                    <a
                      className={styles.link}
                      href="https://about.oceanhero.today/shells-extension"
                    >
                      {getTranslation('new_tab_shell_counter_read')}
                    </a>
                  </div>
                </footer>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <div
        className={`${styles.counterOuter} ${styles.bottlesCounter} bottlesCounterTC`}
      >
        <Fragment>
          <div className={`${styles.counter}`}>
            <div className={`${styles.counterIcon} ${styles.bottle}`} />
            <span style={textStyles}>{formatNumber(bottles)}</span>

            <div className={styles.pyro}>
              <div className={styles.before} />
              <div className={styles.after} />
            </div>
          </div>
        </Fragment>
      </div>
    </div>
  );
};

export default Counter;
